import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { CarouselFactory } from '../../factories/CarouselFactory'
import { EditorComponentContract } from '../EditorComponentContract'
export class Carousel extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.htmlBuilder = HtmlBuilder
    this.factory = new CarouselFactory
    this.innerComponent = false
  }

  elementIds() {
    return ['id']
  }

  elementClasses() {
    return ['classes', 'dotsClasses', 'buttonsClasses']
  }

  elementContents() {
    return ['hasButtons', 'hasDots', 'hasInterval', 'interval']
  }

  elementStyles() {
    return [
      {id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
      {element: 'class', styles: 'buttonsStyles', selector: '.carousel-buttons', variation: null},
      {element: 'class', styles: 'dotsStyles', selector: '.carousel-dots', variation: null},
      {element: 'class', styles: 'activeDotStyles', selector: '.carousel-dots--active', variation: null},
    ]
  }

  info() {
    return {
      name: 'Carousel',
      icon: 'fa-window-restore',
      variations: this.variationsInfo()
    }
  }
}